import React, { useState, useEffect } from "react";
import { Row, Col, Card, Button, Nav, ListGroup, Form, InputGroup } from "react-bootstrap";
import { BsPaperclip } from "react-icons/bs";
import { FaPaperPlane } from "react-icons/fa6";
import f1 from "../../assets/images/people1.svg";
import f2 from "../../assets/images/people2.svg";
import f3 from "../../assets/images/people3.svg";
import g1 from "../../assets/images/c1.svg";
import g2 from "../../assets/images/c2.svg";
import g3 from "../../assets/images/c3.svg";
import chatimage from "../../assets/images/club-list3.svg";
import { useAuth } from "../../context/AuthContext";
import { TbClubsFilled } from "react-icons/tb";
import { FaUserGroup } from "react-icons/fa6";
import { RiLogoutBoxRFill } from "react-icons/ri";

const ChatApp = () => {
    const [privateChats] = useState([
        { id: 1, name: "Anita Stone", lastMessage: "Last message", time: "22m ago", unread: 2, avatar: f1 },
        { id: 2, name: "Charles Yeo", lastMessage: "Last message", time: "4h ago", unread: 0, avatar: f2 },
        { id: 3, name: "Martin Zwilling", lastMessage: "Last message", time: "12d ago", unread: 2, avatar: f3 },
        { id: 4, name: "Emily Carter", lastMessage: "Hey, how are you?", time: "2d ago", unread: 1, avatar: f1 },
        { id: 5, name: "David White", lastMessage: "Meeting at 3 PM", time: "6h ago", unread: 0, avatar: f2 },
        { id: 6, name: "Sophia Green", lastMessage: "Let's catch up!", time: "3d ago", unread: 3, avatar: f3 }
    ]);

    const [groupChats] = useState([
        { id: 7, name: "React Devs", lastMessage: "New update available", time: "1d ago", unread: 3, avatar: g1 },
        { id: 8, name: "Music Lovers", lastMessage: "Check this song!", time: "3d ago", unread: 0, avatar: g2 },
        { id: 9, name: "Football Fans", lastMessage: "Who watched the game?", time: "5d ago", unread: 2, avatar: g3 },
        { id: 10, name: "Tech Enthusiasts", lastMessage: "New AI release", time: "8h ago", unread: 1, avatar: g1 },
        { id: 11, name: "Startup Founders", lastMessage: "Funding round update", time: "4d ago", unread: 0, avatar: g2 },
        { id: 12, name: "Gaming Squad", lastMessage: "Who's playing tonight?", time: "2d ago", unread: 4, avatar: g3 }
    ]);

    const [activeTab, setActiveTab] = useState("private");
    const [selectedChat, setSelectedChat] = useState(privateChats[0]); // Default to first private chat
    const [showAll, setShowAll] = useState(false); // Toggle for "View All"
    const { isAuthenticated } = useAuth();

    const [menuOpen, setMenuOpen] = useState(false);
    useEffect(() => {
        if (activeTab === "private" && privateChats.length > 0) {
            setSelectedChat(privateChats[0]);
        } else if (activeTab === "group" && groupChats.length > 0) {
            setSelectedChat(groupChats[0]);
        }
        setShowAll(false);
    }, [activeTab, privateChats, groupChats]); // Now it's safe to include them

    const currentChats = activeTab === "private" ? privateChats : groupChats;
    const visibleChats = showAll ? currentChats : currentChats.slice(0, 4); // Show 4 chats initially


    return (

        <div className="chat-container">
            <h2 className="mb-20">Messages</h2>
            <Row className="h-90">
                {/* Left Sidebar */}
                <Col md={6} lg={5} className="d-flex flex-column chat-left-panel">
                    <Nav variant="pills" className="mb-3">
                        <Nav.Item>
                            <Nav.Link eventKey="private" active={activeTab === "private"} onClick={() => setActiveTab("private")}>
                                Private Chats
                            </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="group" active={activeTab === "group"} onClick={() => setActiveTab("group")}>
                                Group Chats
                            </Nav.Link>
                        </Nav.Item>
                    </Nav>

                    <div className="chat-left-item">
                        <ListGroup className="overflow-auto">
                            {visibleChats.map((chat) => (
                                <ListGroup.Item
                                    key={chat.id}
                                    className={`d-flex align-items-center ${selectedChat?.id === chat.id ? "active" : ""}`}
                                    onClick={() => setSelectedChat(chat)}
                                >
                                    <div className="message-item-image"><img src={chat.avatar} alt={chat.name} /></div>
                                    <div className="message-item-text flex-grow-1">
                                        <h5 className="mb-0">{chat.name}</h5>
                                        <p className="text-muted">{chat.lastMessage}</p>
                                    </div>
                                    <div className="message-item-time">
                                        {chat.unread > 0 && <span className="badge-tag">{chat.unread}</span>}
                                        <small className="text-muted">{chat.time}</small>
                                    </div>

                                </ListGroup.Item>
                            ))}
                        </ListGroup>

                        {/* View More / View Less Button */}
                        {currentChats.length > 4 && !showAll && (
                            <div className="view-more-btn-wraper">
                                <button className="view-more-btn" onClick={() => setShowAll(true)}>
                                    View More
                                </button>
                            </div>
                        )}
                    </div>
                </Col>

                {/* Chat Window */}
                <Col md={6} lg={7} className="d-flex flex-column chat-panel">
                    {selectedChat ? (
                        activeTab === "group" ? (
                            <Card className="h-100 group-chat">
                                <Card.Header className="d-flex align-items-center">
                                    <div className="chat-header-image">
                                        <img src={selectedChat.avatar} alt={selectedChat.name} />
                                    </div>
                                    <div className="chat-header-text">
                                        <div className="chat-header-text-content">
                                            <h5 className="mb-0">{selectedChat.name}</h5>
                                            <small className="text-muted">@{selectedChat.name.toLowerCase().replace(/\s/g, '')}</small>
                                            <p>12 members</p>
                                        </div>
                                        {/* Optionally, include extra info like participant count */}

                                        <div className="menu-container">
                                            <button disabled={!isAuthenticated} className="menu-button" onClick={() => setMenuOpen(!menuOpen)}>
                                                ⋮
                                            </button>
                                            {menuOpen && (
                                                <div className="menu-dropdown big-menu-dropdown">
                                                    <div className="menu-item">
                                                        <TbClubsFilled /> View Club Profile
                                                    </div>
                                                    <div className="menu-item">
                                                        <FaUserGroup /> View Members
                                                    </div>
                                                    <div className="menu-item delete">
                                                        <RiLogoutBoxRFill /> Leave
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body className="d-flex flex-column overflow-auto p-3" style={{ flex: 1 }}>
                                    {/* Group chat messages – you can style them differently or add a sender name */}
                                    <div className="d-flex flex-column">
                                        <div className="chat-message others">
                                            <p className="chat"><strong>Rose:</strong> Hello everyone!</p>
                                            <small className="time">2m ago</small>
                                        </div>
                                        <div className="chat-message mine">
                                            <p className="chat"><img src={chatimage} alt="Attachment" className="chat-image" aria-hidden="true" /></p>
                                            <p className="chat">My group message</p>
                                            <small className="time">2m ago</small>
                                        </div>
                                        <div className="chat-message others">
                                            <p className="chat"><strong>John:</strong> Hello All!</p>
                                            <small className="time">1m ago</small>
                                        </div>
                                    </div>
                                </Card.Body>
                                <Card.Footer>
                                    <InputGroup>
                                        <Form.Control placeholder="Write your message" />
                                        <Button variant="outline-secondary" className="attuch-btn">
                                            <BsPaperclip />
                                        </Button>
                                        <Button variant="primary" className="send-btn">
                                            <FaPaperPlane />
                                        </Button>
                                    </InputGroup>
                                </Card.Footer>
                            </Card>
                        ) : (
                            // Default UI for private chat
                            <Card className="h-100">
                                <Card.Header className="d-flex align-items-center">
                                    <div className="chat-header-image">
                                        <img src={selectedChat.avatar} alt={selectedChat.name} />
                                    </div>
                                    <div className="chat-header-text">
                                        <div className="chat-header-text-content">
                                            <h5 className="mb-0">{selectedChat.name}</h5>
                                            <small className="text-muted">@{selectedChat.name.toLowerCase().replace(/\s/g, '')}</small>
                                        </div>
                                    </div>
                                </Card.Header>
                                <Card.Body className="d-flex flex-column overflow-auto p-3" style={{ flex: 1 }}>
                                    <div className="d-flex flex-column">
                                        <div className="chat-message mine">
                                            <p className="chat">
                                                <img src={chatimage} alt="Attachment" className="chat-image" aria-hidden="true" />
                                            </p>
                                            <p className="chat">My message</p>
                                            <small className="time">2m ago</small>
                                        </div>
                                        <div className="chat-message others">
                                            <p className="chat">Others' message</p>
                                            <small className="time">2m ago</small>
                                        </div>
                                        <div className="chat-message others">
                                            <p className="chat">Others' message</p>
                                            <small className="time">2m ago</small>
                                        </div>
                                        <div className="chat-message mine">
                                            <p className="chat">My message</p>
                                            <small className="time">2m ago</small>
                                        </div>
                                    </div>
                                </Card.Body>
                                <Card.Footer>
                                    <InputGroup>
                                        <Form.Control placeholder="Write your message" />
                                        <Button variant="outline-secondary" className="attuch-btn">
                                            <BsPaperclip />
                                        </Button>
                                        <Button variant="primary" className="send-btn">
                                            <FaPaperPlane />
                                        </Button>
                                    </InputGroup>
                                </Card.Footer>
                            </Card>
                        )
                    ) : (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <p className="text-muted">Select a chat to start messaging</p>
                        </div>
                    )}
                </Col>

            </Row>
        </div>
    );
};

export default ChatApp;
